export const SET_CODE_GROUPS = 'SET_CODE_GROUPS'

export const setCodeGroups = data => async dispatch => {
  dispatch({
    type: SET_CODE_GROUPS,
    payload: data
  })
}